<body class="home">
     
    <div id="page" class="page">
       <!-- site header html start  -->
       <app-smart-header></app-smart-header>
       <div #home></div>
       <!-- site header html end  -->
       <main id="content" class="site-main">
          <!-- ***home banner html start form here*** -->
          <section class="home-banner-section home-banner-slider">
             <div class="home-banner d-flex flex-wrap align-items-center" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/e443a991-6970-45da-f5f4-4551c157c100/public);">
                <div class="overlay"></div>
                <div class="container">
                   <div class="banner-content text-center">
                      <div class="row">
                         <div class="col-lg-8 offset-lg-2">
                            <h1 class="banner-title">VOYJALEAS</h1>
                            <p>Servicio de consultoría para viajar, estudiar, trabajar o vivir en España.                            </p>
                            <div class="banner-btn">
                               <!-- <a href="javascript: void(0)" class="round-btn" (click)="scrollToElement('packsoffer')">Me interesa</a> -->
                               <a href="javascript: void(0)" (click)="goToCalendly()" class="outline-btn outline-btn-white">Videollamada inicial gratis</a>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </section>

          <section id="politica-privacidad" class="privacy-cnt">
            <h1>Política de Privacidad</h1>
            <p><strong>Última actualización:</strong> 12 de abril de 2025</p>
            
            <p>En VoyJaleas, marca personal dirigida por Sebastián Jiménez Benavides, valoramos y respetamos la privacidad de nuestros clientes. La transparencia y la protección de los datos personales son fundamentales para construir una relación de confianza, especialmente en procesos donde se requiere el tratamiento de información sensible, como la contratación de seguros médicos.

                Esta Política de Privacidad establece las bases sobre las que tratamos los datos de carácter personal que nos facilitan nuestros usuarios a través de los formularios de nuestra web, por correo electrónico o mediante cualquier otro medio de contacto habilitado.</p>
            
            <h2>1. Responsable del tratamiento</h2>
            <ul>
              <li><strong>Nombre completo:</strong> Sebastián Jiménez Benavides</li>
              <li><strong>Marca comercial:</strong> VoyJaleas</li>
              <li><strong>Cédula:</strong> 114460472</li>
              <li><strong>Email de contacto:</strong> voyjaleas.cr@gmail.com</li>
            </ul>
          
            <h2>2. Finalidad del tratamiento</h2>
            <p>Los datos personales se recopilan con las siguientes finalidades:</p>
            <ul>
                <li>Gestionar la solicitud de seguros médicos a través de la correduría colaboradora (Ómnibus – Rosillo Hermanos SA).</li>
                <li>Mantener la comunicación contigo respecto al estado de tu solicitud.</li>
                <li>Cumplir con requisitos legales y administrativos necesarios para la contratación de servicios.</li>
                <li>Enviarte información relevante sobre nuestros servicios (si lo autorizas).</li>
            </ul>

            <h2>3. Datos que recabamos</h2>
            <p>Recogemos datos para gestionar solicitudes de seguros médicos, enviar información sobre servicios y mantener la relación comercial. Dependiendo del servicio solicitado, podemos recoger los siguientes datos personales: </p>
            <ul>
                <li>Nombre, apellidos</li>
                <li>Número de pasaporte o documento de identidad</li>
                <li>Fecha de nacimiento</li>
                <li>Nacionalidad</li>
                <li>Dirección de residencia</li>
                <li>Teléfono y correo electrónico</li>
                <li>Información médica y datos sensibles relacionados con seguros</li>
                <li>Información académica o profesional</li>
            </ul>
          
            <h2>4. Base legal</h2>
            <p>La base legal es tu consentimiento explícito, que se otorga al enviar información mediante nuestros formularios, correos electrónicos u otros medios de contacto.</p>
          
            <h2>5. Destinatarios</h2>
            <p>Podremos compartir tus datos personales exclusivamente con:</p>
            <ul>
                <li>Rosillo Hermanos Correduría de Seguros S.A. (Ómnibus), para gestionar la contratación del seguro.</li>
                <li>Compañías aseguradoras y profesionales sanitarios, cuando sea necesario para tramitar seguros médicos o siniestros.</li>
                <li>Colaboradores tecnológicos y proveedores de servicios, únicamente cuando sea necesario para el funcionamiento técnico de nuestras plataformas.</li> 
            </ul>
            <p>No venderemos ni cederemos tus datos a terceros con fines comerciales.</p>
          
            <h2>6. Conservación de datos</h2>
            <p>Tus datos personales serán conservados durante el tiempo necesario para la gestión de tu solicitud, el cumplimiento de las obligaciones legales y mientras no solicites su supresión.</p>
          
            <h2>7. Derechos del usuario</h2>
            <p>Puedes ejercer los siguientes derechos en cualquier momento, dirigiéndote por escrito a nuestro correo electrónico:
            <ul>
              <li>Acceder a tus datos personales.Acceder a tus datos personales.</li>
              <li>Rectificar datos inexactos.</li>
              <li>Solicitar la supresión de tus datos.</li>
              <li>Oponerte al tratamiento o solicitar su limitación.</li>
              <li>Solicitar la portabilidad de tus datos.</li>
            </ul>
          
            <h2>8. Seguridad</h2>
            <p>Adoptamos medidas técnicas y organizativas adecuadas para garantizar la seguridad y confidencialidad de los datos personales, evitando su alteración, pérdida, tratamiento o acceso no autorizado.</p>
          
            <h2>9. Aceptación</h2>
            <p>Al utilizar nuestros servicios o enviar tus datos, aceptas esta Política de Privacidad. Nos reservamos el derecho de modificarla para adaptarla a cambios legislativos o mejoras del servicio. Las modificaciones serán publicadas en nuestra web y entrarán en vigor desde su publicación.</p>
          </section>


          <section class="home-callback bg-color-callback primary-bg">
             <div class="container">
                <div class="row align-items-center">
                   <div class="col-md-8">
                      <h5 class="sub-title">RESERVA TU VIDEOLLAMADA GRATUITA Y </h5>
                      <h2 class="section-title">COMENCEMOS A PLANEAR TU AVENTURA!!</h2>
                      <p>Nos encantaría conocerte y escuchar tu historia. Agendá una llamada con nuestro equipo para hablar sobre tus necesidades.</p>
                   </div>
                   <div class="col-md-4 text-md-end">
                      <a href="javascript:void(0)" (click)="goToCalendly()" class="outline-btn outline-btn-white">RESERVAR VIDEOLLAMADA</a>
                   </div>
                </div>
             </div>
          </section>
          <!-- ***Home callback html end here*** -->
       </main>
       <!-- ***site footer html start form here*** -->
       <app-smart-footer></app-smart-footer>

       <!-- ***site footer html end*** -->
       <a id="backTotop" href="#" class="to-top-icon">
          <i class="fas fa-chevron-up"></i>
       </a>
       <!-- ***custom search field html*** -->
       <div class="header-search-form">
          <div class="container">
             <div class="header-search-container">
                <form class="search-form" role="search" method="get" >
                   <input type="text" name="s" placeholder="Enter your text...">
                </form>
                <a href="#" (click)="goToPage('home')" class="search-close">
                   <i class="fas fa-times"></i>
                </a>
             </div>
          </div>
       </div>
       <!-- ***custom search field html*** -->
       <!-- ***custom top bar offcanvas html*** -->
       <div id="offCanvas" class="offcanvas-container">
          <div class="offcanvas-inner">
             <div class="offcanvas-sidebar">
                <aside class="widget author_widget">
                   <h3 class="widget-title">OUR PROPRIETOR</h3>
                   <div class="widget-content text-center"> 
                      <div class="profile"> 
                         <figure class="avatar"> 
                            <img src="assets/images/img21.jpg" alt=""> 
                         </figure> 
                         <div class="text-content"> 
                            <div class="name-title"> 
                               <h4> James Watson</h4> 
                            </div> 
                            <p>Accumsan? Aliquet nobis doloremque, aliqua? Inceptos voluptatem, duis tempore optio quae animi viverra distinctio cumque vivamus, earum congue, anim velit</p> 
                         </div> 
                         <div class="socialgroup"> 
                            <ul> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-facebook"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-google"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-twitter"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-instagram"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-pinterest"></i> </a> </li> 
                            </ul> 
                         </div> 
                      </div> 
                   </div>
                </aside>
                <aside class="widget widget_text text-center">
                   <h3 class="widget-title">CONTACT US</h3>
                   <div class="textwidget widget-text">
                      <p>Feel free to contact and<br/> reach us !!</p>
                      <ul>
                         <li>
                            <a href="tel:+01988256203">
                               <i aria-hidden="true" class="icon icon-phone1"></i>
                               +01(988) 256 203
                            </a>
                         </li>
                         <li>
                            <a href="mailtop:info@domain.com">
                               <i aria-hidden="true" class="icon icon-envelope1"></i>
                               info@domain.com
                            </a>
                         </li>
                         <li>
                            <i aria-hidden="true" class="icon icon-map-marker1"></i>
                            3146 Koontz, California
                         </li>
                      </ul>
                   </div>
                </aside>
             </div>
             <a href="#" (click)="goToPage('home')" class="offcanvas-close">
                <i class="fas fa-times" (click)="goToPage('home')"></i>
             </a>
          </div>
          <div class="overlay"></div>
       </div>
       <!-- ***custom top bar offcanvas html*** -->
    </div>

  
 </body>
  